import { deserialize } from 'cerialize'
import { ShortDataModel } from 'Models'
import { SpecialOfferModel } from 'Pages/orders'
import { OrdServiceModel } from './OrdService'

export class ExternalFormModel {
	@deserialize public id: number
	@deserialize public is_deleted: boolean
	@deserialize public creator: ShortDataModel
	@deserialize public products: ShortDataModel[]
	@deserialize public merchant: ShortDataModel
	@deserialize public active: boolean
	@deserialize public approve: boolean
	@deserialize public fixed_products: boolean
	@deserialize public product_ids: number[]
	@deserialize public partner: ShortDataModel
	@deserialize public token: string
	@deserialize public ds_landing_url: string
	@deserialize public partner_site_urls: string[]
	@deserialize public ad_marking_state: string
	@deserialize public ad_marking_last_errors: OrdServiceModel[]
	@deserialize public advertisement: boolean
	@deserialize public without_marker: boolean
	@deserialize public rbidos: boolean
	@deserialize public special_offer?: SpecialOfferModel
	@deserialize public platforms?: ShortDataModel[]
	@deserialize public iframe?: boolean
	@deserialize public landing_url_with_marker: string
	@deserialize public skip_call: boolean
	@deserialize public depersonalized: boolean
	@deserialize public erid: string
	@deserialize public lead_bearer: string
	@deserialize public need_confirm_phone: boolean
	@deserialize public skip_required_products: boolean
}
